// Política de senha do Cognito (validada pelo backend antes de chamar a AWS):
// mínimo 8 caracteres, 1 maiúscula, 1 minúscula, 1 número e 1 símbolo.
// Fonte única de verdade — reutilizada no login (recuperação de senha) e no
// painel admin (troca de senha), para as duas telas nunca divergirem.

export const passwordPolicyRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export type PasswordRequirement = {
  label: string;
  test: (value: string) => boolean;
};

export const passwordRequirements: PasswordRequirement[] = [
  {
    label: 'Pelo menos 8 caracteres',
    test: (value) => value.length >= 8,
  },
  {
    label: 'Uma letra maiúscula (A-Z)',
    test: (value) => /[A-Z]/.test(value),
  },
  {
    label: 'Uma letra minúscula (a-z)',
    test: (value) => /[a-z]/.test(value),
  },
  {
    label: 'Um número (0-9)',
    test: (value) => /\d/.test(value),
  },
  {
    label: 'Um caractere especial (!@#$%...)',
    test: (value) => /[^A-Za-z0-9]/.test(value),
  },
];

export function isStrongPassword(value: string): boolean {
  return passwordRequirements.every((requirement) => requirement.test(value));
}
